import api from "./client";

export const getClinics = (params = {}) => {
  return api.get("/api/clinics/", {
    params,
  });
};

export const getClinicDetail = (clinicId) => {
  return api.get(`/api/clinics/${clinicId}/`);
};

export const getClinicDashboard = () => {
  return api.get("/api/clinics/dashboard/");
};

export const getAdminClinics = () => {
  return api.get("/api/clinics/admin/");
};

export const getAdminClinicDetail = (
  clinicId
) => {
  return api.get(
    `/api/clinics/admin/${clinicId}/`
  );
};

export const createClinic = (data) => {
  return api.post(
    "/api/clinics/admin/",
    data
  );
};

export const updateClinic = (
  clinicId,
  data
) => {
  return api.put(
    `/api/clinics/admin/${clinicId}/`,
    data
  );
};

export const resetClinicPassword = (
  clinicId
) => {

  return api.post(

    `/api/clinics/admin/${clinicId}/reset-password/`

  );
};
